import { GetterTree } from 'vuex';
import * as types from './types';

export default <GetterTree<calendar.state.CalendarState, RootState>>{

    //
    // ──────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────
    //

    [types.COMMON_SHOW_CONTENTMASK](state) {
        return state.showContentMask;
    },

    [types.SIDEBAR_CURRENT](state){
        return state.folders.currentFolder;
    },

    [types.COMMON_ROOM_LIST](state){
        return state.myRooms;
    },    

    [types.SIDEBAR_CONTEXT_STATE](state) {        
        return state.currentContextState;
    },

    [types.COMMON_DATE_CURRENT](state) {
        return state.currentDate;
    },

    [types.COMMON_ERROR_MESSAGE](state) {
        return state.currentError;
    },

    [types.COMMON_CURRNT_USER](state) {
        return state.currentUser;
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: F O L D E R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    [types.FOLDER_LIST_TREE](state){       
        return state.folders;
    },

    [types.FOLDER_ROOT](state) {
        return state.folders.mylist.items[0];
    },
    
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C A L E N D A R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    [types.CALENDAR_CURRENT_APPOINTMENT](state) {
        return state.setAppointment;
    },
    
    [types.CALENDAR_DATE_NEXT](state) {
        return state.calendarDateMatrix;
    },

    [types.CURRENT_CALENDAR_ITEM] (state) {
        return state.currentCalendarItem;
    },

    [types.CALENDAR_PRINT_LIST] (state) {
        return state.calendarPrintEvents;
    },

    [types.CALENDAR_HIDE_SHOW] (state) {
        return state.calendarHideShow;
    },

    [types.CALENDAR_DATE_CURRENT](state) {
        return state.currentCalendarDate;
    },

    [types.CALENDAR_DATETIME_CURRENT](state) {
        return state.currentCalendarTime;
    },

    [types.CALENDAR_EVENT_SELECT_ID](state) {
        return state.calendarSelectedEventID;
    },

    [types.CALENDAR_DAILY_EVENT_LIST](state) {
        return state.calendarDailyEvents;
    },

    [types.CALENDAR_MONTH_MATRIX_LIST](state) {
        return state.calendarMonthMatrix;
    },
    
    [types.CALENDAR_NEXT](state) {
        return state.calendarNextMonthMatrix;
    },

    [types.CALENDAR_WEEK_MATRIX_LIST](state) {
        return state.calendarWeekMatrix;
    },

    [types.CALENDAR_DATE_MATRIX_LIST](state) {
        return state.calendarDateMatrix;
    },

    [types.CALENDAR_VIEWMODE](state) {
        return state.calendarMode;
    },
    
    [types.CALENDAR_EVENT_ADD](state) {
        return state.newCalendar;
    },

    [types.CALENDAR_EVENT_EDIT](state) {
        return state.editCalendar;
    },

    [types.CALENDAR_SEARCH_OPTION](state) {
        return state.toolbar.search;
    },

    [types.CALENDAR_SHARED_SHOW](state) {
        return state.toolbar.showDetailShareOption;
    },

    [types.CALENDAR_SEARCH_SHOW](state) {
        return state.toolbar.showDetailSearchOption;
    },

    [types.CALENDAR_RECURRING_SHOW](state) {
        return state.showRecurringOption;
    },

    [types.CALENDAR_SEARCH_LIST](state) {
        return state.searchEvents;
    },

    [types.GET_ACTION](state) {
        return state.loadedActions;
    },   

    [types.CALENDAR_CURRENT_RECURRING](state) {
        return state.currentRecurringItem;
    },

    [types.CALENDAR_TODAY_MODE](state) {
        return state.todayMode;
    }
};
